// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '24px 16px 0px',
        mt: 'auto',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            opacity: 0.6,
          }}
        />
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            letterSpacing: '0.02em',
          }}
        >
          &copy; {new Date().getFullYear()} Food Delivery SAS Algharabia
        </Typography>
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: 'text.disabled',
          fontWeight: 400,
          fontSize: '0.6875rem',
        }}
      >
        Powered by Yoro Technologies
      </Typography>
    </Stack>
  );
}
